// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2nYLz","productName":"Table_productName__3lmlB"};